import React, { Suspense } from 'react';
import { Tab } from 'semantic-ui-react';
import ClientesList from '../../../../../../../services/storageClient.js';
import CreateContext from './../../store/CreateContext';
import axios from 'axios';
import { Services } from '../../../../Services';
import moment from 'moment';

const Fields = React.lazy(() => import('./components/Fields'));
const Filters = React.lazy(() => import('./components/Filters'));
const Order = React.lazy(() => import('./components/Order'));
const Preview = React.lazy(() => import('./components/Preview'));





function ReportPreview(props) {
  const clientSave = new ClientesList();
  const context = React.useContext(CreateContext);
  const clientesSelect = clientSave.getAuthentication('client')
  const [gettingCatalogs, setGettingCatalaogs] = React.useState(false);
  const [loadingEdit, setLoadingEdit] = React.useState(false);
  const { reportId } = props;


  const GetLevelInfo = React.useCallback(async () => {
    // console.log('ando aqui');
    try {
      setGettingCatalaogs(true);
      const LevelInfo = await axios.post(`${Services.REPORTS.path}report/builder/levelinfo`);
      // console.log('LevelInfo.data.data-------->', LevelInfo.data.data);
      // console.log('LevelInfo.data.filters----->', LevelInfo.data.filters);
      context.set_level_info(LevelInfo.data.data);
      context.set_filters_data(LevelInfo.data.filters);
      setGettingCatalaogs(false);
      return LevelInfo.data.data;
    } catch (err) {
      console.error('this is the error -->', err);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getReportData = React.useCallback(async () => {
    try {
      setLoadingEdit(true);
      const body = {
        reportId: reportId
      };
      const reportInfo = await axios.post(`${Services.REPORTS.path}report/builder/edit`, body);
      const model = reportInfo.data.model;

      context.set_report_name({ value: model.report_name, valid: true });
      context.set_report_description({ value: model.report_description, valid: true });
      context.onChangeType(model.report_type);
      context.set_selected_module(model.module_selected);
      context.set_fields(model.selected_fields);
      context.set_filter(model.filters);
      context.set_order_fields(model.order);
      context.set_frequency(model.frequency);
      context.set_share_to(model.share_to);

      context.update_config({ key: model.frequency, value: model.recurrence });
      if (model.startDate) context.update_config({ key: 'startDate', value: { value: model.startDate ? moment(model.startDate) : null } });
      if (model.endDate) context.update_config({ key: 'endDate', value: { value: model.endDate ? moment(model.endDate) : null } });
      if (model.hour) context.update_config({ key: 'hour', value: { value: model.hour ? moment(model.hour) : null } });
      if (model.emailList) context.set_emailList(model.emailList);
      context.update_config({ key: 'day', value: model.day ? model.day : null });

      const LevelINFO = await GetLevelInfo(model.module_selected);
      // console.log('LevelINFO', LevelINFO);
      formatLevelInfo(model.selected_fields, LevelINFO);
      // setLoadingEdit(false);
    } catch (error) {
      console.error('getReportData -- ', error);
      Notification(
        'Error',
        'Error when consulting report information',
        'Error'
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportId]);

  function formatLevelInfo(selected, levelinfo) {
    // console.log('selected--->', selected);
    // console.log('levelinfo--->', levelinfo);
    for (let index = 0; index < selected.length; index++) {
      const item_selected = selected[index];
      // console.log('item_selected', item_selected);

      for (let indexI = 0; indexI < levelinfo.length; indexI++) {
        const item = levelinfo[indexI];
        // console.log('iteem', item)
        if (item.id === item_selected.origin) {
          levelinfo[indexI].options = item.options.filter((item) => item.id !== `column-${item_selected.value}`);
        }
      }
    }
    // console.log('levelinfo--->', levelinfo);
    context.set_level_info(levelinfo);
  }


  React.useEffect(() => {
    GetLevelInfo();

    // console.log('Inside the effect');
    if (props.action === 'edit') {
      getReportData();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [GetLevelInfo, getReportData]);

  const tabs = [
    { menuItem: 'Data', render: () => <Suspense fallback={<div>Loading...</div>}> <Fields action={props.action} reportId={props.reportId} /></Suspense> },
    { menuItem: 'Filters', render: () => <Suspense fallback={<div>Loading...</div>}> <Filters /></Suspense> },
    { menuItem: 'Sort By', render: () => <Suspense fallback={<div>Loading...</div>}> <Order /></Suspense> },
    { menuItem: 'Preview', render: () => <Suspense fallback={<div>Loading...</div>}> <Preview clients={clientesSelect} /></Suspense> }
  ];

  return (
    // <div className='col-md-12 mt-5'>
    <Tab
      menu={{ secondary: true, className: 'myWrapped' }}
      menuPosition={'right'}
      panes={tabs}
    />
    // </div>
  );
}

export default ReportPreview;